import { StartTreePoint } from "../start-tree-point"
import { useEffect, useRef } from "react"

const StartTree = ({model}) => {
  const materialRef = useRef();
  const treeStartMaterialRef = useRef();
  const wallRef = useRef();

  useEffect(() => {
    if (!materialRef.current || !treeStartMaterialRef.current || !wallRef.current) return;

    const material = materialRef.current;
    const treeStartMaterial = treeStartMaterialRef.current;
    const wallMaterial = wallRef.current;

    // Масив кольорів
    const colors = [
      { r: 1, g: 1, b: 1 }, // Фіолетовий
      { r: 0, g: 0, b: 1 }, // Синій
      { r: 1, g: 0.5, b: 0 }, // Помаранчевий
    ];

    let colorIndex = 0;

    const changeColor = () => {
      // Змінюємо колір матеріалу для обох елементів
      const color = colors[colorIndex];
      material.color.setRGB(color.r, color.g, color.b);
      treeStartMaterial.color.setRGB(color.r, color.g, color.b);  // Застосовуємо до tree-start
      wallMaterial.color.setRGB(color.r, color.g, color.b);  // Застосовуємо до tree-start
      wallMaterial.emissive.setRGB(color.r, color.g, color.b);

      // Перемикаємо на наступний колір
      colorIndex = (colorIndex + 1) % colors.length;
    };

    changeColor(); // Змінюємо колір відразу
    const interval = setInterval(changeColor, 3000); // Міняємо колір кожні 3 секунди

    // Очищення інтервалу при демонтажі компонента
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <primitive object={model.nodes["tree-start"]}>
        <meshStandardMaterial ref={treeStartMaterialRef} />
      </primitive>
      <primitive object={model.nodes["zag_points"]}>
        <meshStandardMaterial ref={wallRef} />
      </primitive>
      <primitive object={model.nodes["tree-ramp"]} />
      <primitive object={model.nodes["zag_points"]}>
        <meshStandardMaterial ref={wallRef} />
      </primitive>
      <points
        geometry={model.nodes["tree-points"].geometry}
        position={model.nodes["tree-points"].position}
        rotation={model.nodes["tree-points"].rotation}
      >
        <pointsMaterial ref={materialRef} size={0.05} />
      </points>
    </>
  );
}

export {
  StartTree
}
